import { render, staticRenderFns } from "./CustomImage.vue?vue&type=template&id=51623532&scoped=true"
import script from "./CustomImage.vue?vue&type=script&lang=js"
export * from "./CustomImage.vue?vue&type=script&lang=js"
import style0 from "./CustomImage.vue?vue&type=style&index=0&id=51623532&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51623532",
  null
  
)

export default component.exports